/* eslint-disable eol-last */
import Configuration from '../../utils/config';
import AxiosInstance from '../../interceptor/http-intercepor';
import Axios from 'axios';
import { alertService } from '../../components/toaster/alert.service';
import { loaderService } from '../../components/loader/loader.service';

class VendorService {
    constructor() {
        this.config = new Configuration();
    }

    async getCompanySuggestion(companyName) {
        const self = this;
        loaderService.show(true);
        const userId = localStorage.getItem('userId');
        let url = `${this.config.baseUrl}${this.config.getCompanySuggestion}?name=${companyName}`;
        // const url = this.config.baseUrl +this.config.getCompanyByUser + userId;
        return AxiosInstance.get(url)
          .then((response) => {
            loaderService.show(false);
            if (response.status !== 200) {
              this.handleResponseError(response);
            }
            return response.data?.data?.length ? response.data.data : [];
          })
          .then((res) => {
            return res;
          })
          .catch((error) => {
            self.handleError(error);
          });
      }

    async addVendor(vendorObj) {
        loaderService.show(true);
        const self = this;
        const userId = localStorage.getItem('userId');
        vendorObj.userId = userId;
        const url = this.config.addVendor;
        return AxiosInstance.post(url, vendorObj)
            .then((response) => {
                loaderService.show(false);
                if (response.status !== 200) {
                    this.handleResponseError(response);
                }
                return response.data;
            })
            .then((res) => {
                return res;
            })
            .catch((error) => {
                self.handleError(error);
            });
    }

    async getVendor(rfpId) {
        const self = this;
        loaderService.show(true);
       // const userId = localStorage.getItem('userId');
        const url = this.config.getVendor + rfpId;
        return AxiosInstance.get(url)
            .then((response) => {
                loaderService.show(false);
                if (response.status !== 200) {
                    this.handleResponseError(response);
                }
                return response.data;
            })
            .then((res) => {
                return res;
            })
            .catch((error) => {
                self.handleError(error);
            });
    }

    async deleteVendorEmail(id) {
        loaderService.show(true);
        const self = this;
        let emailObj={}
        const userId = localStorage.getItem('userId');
        emailObj.userId = userId;
        emailObj.id=id;
        const url = this.config.deleteEmail;
        return AxiosInstance.post(url, emailObj)
            .then((response) => {
                loaderService.show(false);
                if (response.status !== 200) {
                    this.handleResponseError(response);
                }
                return response.data;
            })
            .then((res) => {
                return res;
            })
            .catch((error) => {
                self.handleError(error);
            });
    }

    handleResponseError(response) {
        loaderService.show(false);
        throw new Error(`HTTP error, status = ${response.status}`);
    }

    handleError(error) {
        loaderService.show(false);
        if (error.response) {
            const autoClose = true;
            const keepAfterRouteChange = false
            alertService.error(error.response.data.message, { autoClose, keepAfterRouteChange })
            //alertService.error('Error hhh', { id: 'left-alert' });
            // Request made and server responded
            console.log(':: error', error.response.data);
            // alert(error.response.data.message);
            console.log(':: error', error.response.status);
            console.log(':: error', error.response.headers);
        } else if (error.request) {
            // The request was made but no response was received
            console.log(':: error', error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log(':: Error', error.message);
        }
    }
}

export default VendorService;